function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M50 4.5V19.5C50 20.3398 49.3286 21 48.4734 21H5.52655C4.67144 21 4 20.3398 4 19.5V4.5C4 2.00977 6.04534 0 8.57965 0H45.4204C47.9547 0 50 2.00977 50 4.5Z",
  fill: "#96AEC2"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M48.4735 21H27V0H45.4204C47.9547 0 50 2.00977 50 4.5V19.5C50 20.3398 49.3286 21 48.4735 21Z",
  fill: "#8198AC"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.5298 21H14.4702C12.0054 21 10 19.1495 10 16.875V14.125C10 11.8505 12.0054 10 14.4702 10H20.5298C22.9946 10 25 11.8505 25 14.125V16.875C25 19.1495 22.9946 21 20.5298 21Z",
  fill: "#EDE9E8"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M39.5298 21H33.4702C31.0054 21 29 19.1495 29 16.875V14.125C29 11.8505 31.0054 10 33.4702 10H39.5298C41.9946 10 44 11.8505 44 14.125V16.875C44 19.1495 41.9946 21 39.5298 21Z",
  fill: "#DFD7D5"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M54 32V42.5C54 43.3398 53.3042 44 52.418 44H49.2539C48.3677 44 47.6719 43.3398 47.6719 42.5V38H6.32812V42.5C6.32812 43.3398 5.63228 44 4.74609 44H1.58203C0.695847 44 0 43.3398 0 42.5V32L4.99947 29H50.0449L54 32Z",
  fill: "#728EA7"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M54 32V42.5C54 43.3398 53.3042 44 52.418 44H49.2539C48.3677 44 47.6719 43.3398 47.6719 42.5V38H27V29H50.0449L54 32Z",
  fill: "#637E96"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M54 23.5V31H0V23.5C0 21.0098 2.11967 19 4.74609 19H49.2539C51.8803 19 54 21.0098 54 23.5Z",
  fill: "#FF7C91"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M54 23.5V31H27V19H49.2539C51.8803 19 54 21.0098 54 23.5Z",
  fill: "#E9526A"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 54,
    height: 44,
    viewBox: "0 0 54 44",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

export default __webpack_public_path__ + "static/media/bedroom.c733dfe4.svg";
export { SvgComponent as ReactComponent };